import { AxiosResponse } from 'axios';
import { appContextPost } from './httpCommon/appAxios.service';
import { MARKETPLACE_INVENTORY_PAYMENT_ENDPOINTS } from '../constants/apiEndpoints';
import { CardOnFilePayload, InstantPaymentPayload } from '../types/interfaces/marketplacePayment.inteface';

const accountMarketplacePaymentBaseUrl = (accountId: number): string =>
  `${MARKETPLACE_INVENTORY_PAYMENT_ENDPOINTS.MARKETPLACE_INVENTORY_PAYMENT}${accountId}`;

export const makeMarketplacePaymentUsingCardOnFile = (
  accountId: number,
  payload: CardOnFilePayload,
): Promise<AxiosResponse<unknown>> =>
  appContextPost(
    `${accountMarketplacePaymentBaseUrl(accountId)}${MARKETPLACE_INVENTORY_PAYMENT_ENDPOINTS.CARD_ON_FILE_PAYMENT}`,
    payload,
  );

export const makeInstantMarketplacePayment = (
  accountId: number,
  payload: InstantPaymentPayload,
): Promise<AxiosResponse<unknown>> =>
  appContextPost(
    `${accountMarketplacePaymentBaseUrl(accountId)}${MARKETPLACE_INVENTORY_PAYMENT_ENDPOINTS.INSTANT_PAYMENT}`,
    payload,
  );
